import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBridge"><Circle cx="5" cy="16" r="2.75" stroke="currentColor" strokeWidth="1.5"/><Circle cx="19" cy="16" r="2.75" stroke="currentColor" strokeWidth="1.5"/><Path d="M5 13V12.25C5 8.38401 8.13401 5.25 12 5.25C15.866 5.25 19 8.38401 19 12.25V13" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconBridge;
